<template>
  <v-card>
    <v-form @submit.prevent="submitAddContractor()" ref="addContractorForm">
      <v-card-title>
        <span class="headline">Add Contractor {{isRequest || contractor.request ? 'Request' : ''}}</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field label="* Name" v-model="contractor.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field label="* ABN" v-model="contractor.abn" :rules="abnRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Phone"
              v-model="contractor.contactPhone"
              :rules="contactPhoneRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Email"
              v-model="contractor.contactEmail"
              :rules="contactEmailRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Street address 1"
              v-model="contractor.addressStreet1"
              :rules="addressRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Street address 2"
              v-model="contractor.addressStreet2"
              :rules="addressRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field label="City" v-model="contractor.addressCity" :rules="addressCityRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete
              label="State"
              :items="states"
              v-model="contractor.addressState"
              no-data-text="An error occured"
              color="indigo"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              label="Post code"
              v-model="contractor.addressPostCode"
              :rules="addressPostCodeRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Admin fee percentage"
              v-model="contractor.adminFeePercentage"
              :rules="adminFeePercentageRules"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Sub-contractor Override"
              v-model="contractor.override"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="!isRequest">
            <v-switch label="Request" v-model="contractor.request"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="addingContractor"
        >{{ isRequest || contractor.request ? 'Create Request' : 'Add'}}</v-btn>
      </v-card-actions>
    </v-form>
    <inductions-panel
      :projects="projects"
      :discarding="discarding"
      @selectedChanged="onSelectedChanged"
      @discard="discarding = false"
    ></inductions-panel>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ContractorService from '@/services/requests/contractorService'

// MIXINS
import ContractorValidation from '@/services/validation/contractorValidation'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'

// COMPONENTS
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
import InductionsPanel from '@/components/ui/inductionsPanel'
export default {
  components: {
    DatePickerWrapper,
    InductionsPanel,
  },
  mixins: [ContractorValidation, getProjects],
  props: {
    isRequest: Boolean,
  },
  data() {
    return {
      contractor: {
        name: '',
        addressStreet1: '',
        addressStreet2: '',
        addressCity: '',
        addressState: '',
        addressPostCode: '',
        contactEmail: '',
        contactPhone: '',
        abn: '',
        adminFeeRequired: true,
        adminFeePercentage: 5,
        override: 0,
        contractorId: '',
        request: false,
      },
      selectedProjects: [],
      addingContractor: false,
      loadingContractors: false,
      states: ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NT', 'ACT'],
      discarding: false,
    }
  },
  methods: {
    submitAddContractor() {
      if (!this.$refs.addContractorForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.addContractor()
    },
    addContractor() {
      this.loading = true
      const postedContractor = this.contractor
      postedContractor.selectedProjects = this.selectedProjects
      if (this.isRequest) this.contractor.request = this.isRequest
      ContractorService.addContractor(postedContractor)
        .then((result) => {
          this.loading = false
          this.$store.commit('contractors/addToArrayState', {
            prop: 'contractors',
            value: result.data.result,
          })
          this.resetForm()
          this.snack({ text: 'Contractor was added!', color: 'green' })
          this.close()
        })
        .catch((err) => {
          this.snackError()
          this.addingContractor = false
          console.log(err)
        })
    },
    onSelectedChanged(val) {
      this.selectedProjects = val
    },
    resetForm() {
      this.contractor.name = ''
      this.contractor.contactEmail = ''
      this.contractor.contractor = ''
      this.contractor.override = 0
      this.$refs.addContractorForm.resetValidation()
      this.discarding = true
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
</style>
